<template>
  <div class="index">

    <div class="title tt-uc">
      <p>Index of work</p>
    </div>
    <div class="links-wrap">
    <div class="links">

      <div class="desc grey tt-uc">
        <div class="lt">
          <p>Year</p>
          <p>Project</p>
        </div>
        <div class="rt">
          <p>Description</p>
          <p>
          </p>
        </div>
      </div>

      <router-link class="link" to="/work/coop">
      <div class="lt">
        <p class="">2021</p>
        <p class="">Coop</p>
      </div>
      <div class="rt">
        <p class="">Grocery Store Chain</p>
        <p class="arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16" width="16"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
        </p>
      </div>
      </router-link>

      <router-link class="link" to="/work/bambuser">
      <div class="lt">
        <p class="">2019</p>
        <p class="">Bambuser</p>
      </div>
      <div class="rt">
        <p class="">Live Video Shopping</p>
        <p class="arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16" width="16"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
        </p>
      </div>
      </router-link>

      <router-link class="link" to="/work/ticker">
      <div class="lt">
        <p class="">2021</p>
        <p class="">Ticker</p>
      </div>
      <div class="rt">
        <p class="">Financial Investment Platform</p>
        <p class="arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16" width="16"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
        </p>
      </div>
      </router-link>

      <router-link class="link" to="/work/tv4play">
      <div class="lt">
        <p class="">2019</p>
        <p class="">TV4 Play</p>
      </div>
      <div class="rt">
        <p class="">Streaming Platform</p>
        <p class="arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16" width="16"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
        </p>
      </div>
      </router-link>

      <router-link class="link" to="/work/algorhythm">
      <div class="lt">
        <p class="">2022</p>
        <p class="">Algorhythm</p>
      </div>
      <div class="rt">
        <p class="">Music Streaming Platform</p>
        <p class="arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16" width="16"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
        </p>
      </div>
      </router-link>

      <router-link class="link" to="/work/revir">
        <div class="lt">
          <p class="">2020</p>
          <p class="">Revir</p>
      </div>
      <div class="rt">
          <p class="">Apparel Brand</p>
          <p class="arrow">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="16" width="16"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"/></svg>
          </p>
        </div>
      </router-link>


    </div>
    </div>
    

  </div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      isActive: false,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/_vars.scss";
@import "../scss/_mixins.scss";
@import "../scss/_classes.scss";

.index {
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    flex-grow: 1;
    align-items: center;
    p {
      @include useMargin(padding);
    }
  }
  .desc {
    display: flex;
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,1);
    // @include useInnerMargin(padding-bottom);
    padding-bottom: 5px;
    font-size: .7rem;
  }
  .links-wrap {
    flex-grow: 1;
  .links:hover .link:not(:hover) {
    color: rgba(0,0,0,.4);
    border-bottom: 1px solid rgba(0,0,0,.4);
    fill: rgba(0,0,0,.4);
  }
  .links {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    @include useMargin(padding);
    .link {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      text-decoration: none;
      // @include useMargin(padding-top);
      // @include useInnerMargin(padding-bottom);
      padding-top: 10px;
      padding-bottom: 5px;
      border-bottom: 1px solid rgba(0,0,0,1);
      &:hover {
        // border-bottom: 1px solid rgba(0,0,0,1);
        // background-color: black;
        // color: black;
      }
      .rt {
        justify-content: space-between;
      }
      .arrow {
        display: flex;
        align-items: center;
        svg {
          transform: rotate(-90deg);
        }
      }
    }
  }
  }
  .lt, .rt {
    width: 100%;
    display: flex;
  }
  .lt {
    p {
      flex: 0 100%;
        &:nth-child(2) {
          @media #{$desktop} {
          text-transform: uppercase;
          }
        }
      @media #{$mobile} {
        &:first-child {
          // flex: 0 50%;
          display: none;
        }
      }
    }
    @media #{$mobile} {
      width:50%;
    }
  }
}

</style>
